/**
 * Single source for Alfred AI target-customer guide access (must match `App.tsx` route guards).
 */
export const ALFRED_AI_GUIDE_ALLOWED_DOMAINS = ['@alfred.ai'] as const;
export const ALFRED_AI_GUIDE_ALLOWED_EMAILS = [
  'will@alfred.ai',
  'iwan.lubberts@alphadigital.ai',
] as const;

export const ALFRED_AI_GUIDE_PATH = '/alfred-ai-target-customer-guide';

/** Paths guide-only clients may visit while authenticated (hard lock in ProtectedRoute). */
export const ALFRED_GUIDE_ONLY_ALLOWED_PATHS = [
  ALFRED_AI_GUIDE_PATH,
  '/auth',
  '/auth/claim',
  '/reset-password',
  '/settings',
  '/waiting-approval',
] as const;

function normalizePathForGuideLock(pathname: string): string {
  if (!pathname || pathname === '/') return '/';
  return pathname.replace(/\/+$/, '');
}

export function canAccessAlfredAiTargetGuide(email: string | undefined): boolean {
  if (!email) return false;
  const lower = email.toLowerCase();
  if (ALFRED_AI_GUIDE_ALLOWED_EMAILS.some((e) => e.toLowerCase() === lower)) return true;
  return ALFRED_AI_GUIDE_ALLOWED_DOMAINS.some((d) => lower.endsWith(d.toLowerCase()));
}

/** @alias canAccessAlfredAiTargetGuide */
export const isAlfredGuideOnlyUser = canAccessAlfredAiTargetGuide;

export function isPathAllowedForAlfredGuideOnly(pathname: string): boolean {
  const normalized = normalizePathForGuideLock(pathname);
  return ALFRED_GUIDE_ONLY_ALLOWED_PATHS.some((p) => normalizePathForGuideLock(p) === normalized);
}

/** Default landing path for an approved client after login / approval. */
export function getApprovedClientHomePath(email: string | undefined): string {
  return canAccessAlfredAiTargetGuide(email) ? ALFRED_AI_GUIDE_PATH : '/dashboard';
}
